import React from 'react';
import styles from './styles.module.scss';
import { formatHour } from '@utils/formatDisplay';
import { I_SegmentInfo } from '@interfaces/common';
import cN from 'classnames';

import { OclockIcon } from '@features/ui/Icons';


interface I_TransferInfoProps {
    segmentInfos: I_SegmentInfo[];
    index: number;
    transferSituation: I_TransferSituation | null;
}

interface I_TransferSituation {
    AirportDesc: string | null
    isHightLight: boolean;
}

const TransferInfo = ({ segmentInfos, index, transferSituation }: I_TransferInfoProps) => {
    const formattedDuration = formatHour(segmentInfos[index].TransferDuration);

    return (
        <div className={cN(styles.transfer, { [styles.transfer_red]: transferSituation?.isHightLight })}>
            <span>{transferSituation?.AirportDesc}</span>
            <span className={styles.icon}><OclockIcon /></span>
            <span className={styles.notice}>
                {formattedDuration}
            </span>
        </div>
    );

};

export default TransferInfo;
